// extracted by mini-css-extract-plugin
export default {"socialBtn":"SocialBtn_socialBtn__vW5nu"};